/**
 * Decorator for vendor's logoutCommand to clear all user-specific data on logout.
 * Fixes NAVI-22398: Cross-user notification caching issue.
 */
angular.module('app').config(function ($provide) {
  $provide.decorator(
    'logoutCommand',
    function ($delegate, $stickyState, $deepStateRedirect, $cacheFactory, $injector, ngDeeplinkConfig) {
      return function decoratedLogoutCommand() {
        // Reset sticky states
        $stickyState.reset('*');
        $deepStateRedirect.reset();

        // Clear the one-time destination after it has been used
        ngDeeplinkConfig.clearStoredDeeplink();

        // Clear HTTP cache
        $cacheFactory.get('$http').removeAll();

        // Clear session storage
        window.sessionStorage.clear();

        // Clear ORM datastores
        // IMPORTANT: This is an explicit allowlist by design (not all services should be cleared).
        // When adding new user-specific datastores/datasources, add them here.
        // Only include datastores that cache user-specific data that should not persist across logins.
        const datastoresToClear = [
          'ngPathTaskDatastore',
          'ngPathItemDatastore',
          'ngConversationDatastore',
          'ngHoldDatastore',
          'ngSurveyDatastore',
          'ngStudygroupsPriorityFeedDatasource',
          'ngApptSummariesDatasource',
          'ngNotesDatasource',
          'ngProgressReportsDatasource',
          'staffTodoListDatastore',
          'reminderListDatastore'
        ];

        datastoresToClear.forEach(function (datastoreName) {
          try {
            const datastore = $injector.get(datastoreName);
            if (datastore && datastore.clear) {
              datastore.clear();
            }
          } catch (e) {
            // Datastore might not exist in all environments
          }
        });

        // Call the original vendor logoutCommand
        return $delegate.apply(this, arguments);
      };
    }
  );
});
